import React from 'react';
import PropTypes from 'prop-types';
import ReactPagination from 'react-js-pagination';
import classNames from 'classnames/bind';
import Icon from '@jll/icon';
import styles from './pagination.scss';

const getStyles = classNames.bind(styles);

const Pagination = ({ totalItemsCount, pageRangeDisplayed, itemsCountPerPage, ...other }) => {
    const componentMainClass = 'pagination';
    const firstPageTextClasses = getStyles(`${componentMainClass}__icon--first`, 'far', 'fa-step-backward');
    const lastPageTextClasses = getStyles(`${componentMainClass}__icon--last`, 'far', 'fa-step-forward');
    const nextPageClasses = getStyles(`${componentMainClass}__icon--next`, 'fal', 'fa-caret-right');
    const previousPageClasses = getStyles(`${componentMainClass}__icon--previous`, 'fal', 'fa-caret-left');

    return (
        <ReactPagination
            activeLinkClass={styles[`${componentMainClass}__page-link--active`]}
            disabledClass={styles[`${componentMainClass}__page--disabled`]}
            firstPageText={<Icon className={firstPageTextClasses} />}
            innerClass={styles[`${componentMainClass}__wrapper`]}
            itemClass={styles[`${componentMainClass}__page`]}
            itemClassNext={styles[`${componentMainClass}__page-next`]}
            itemClassPrev={styles[`${componentMainClass}__page-previous`]}
            itemsCountPerPage={itemsCountPerPage}
            lastPageText={<Icon className={lastPageTextClasses} />}
            linkClass={styles[`${componentMainClass}__page-link`]}
            linkClassFirst={styles[`${componentMainClass}__page-link--first`]}
            linkClassLast={styles[`${componentMainClass}__page-link--last`]}
            linkClassNext={styles[`${componentMainClass}__page-link--next`]}
            linkClassPrev={styles[`${componentMainClass}__page-link--previous`]}
            nextPageText={<Icon className={nextPageClasses} />}
            pageRangeDisplayed={pageRangeDisplayed}
            prevPageText={<Icon className={previousPageClasses} />}
            totalItemsCount={totalItemsCount}
            {...other}
        />
    );
};

Pagination.propTypes = {
    /** The total number of pages. */
    totalItemsCount: PropTypes.number.isRequired,
    /** The range of pages displayed. Default is 5, set by plugin configurations. */
    pageRangeDisplayed: PropTypes.number.isRequired,
    /** The range of items displayed per page. */
    itemsCountPerPage: PropTypes.number,
    /** Pagination action handler. */
    onChange: PropTypes.func.isRequired
};

Pagination.defaultProps = {
    itemsCountPerPage: 20
};

export default Pagination;
